import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Form, Errors, actions, Control} from 'react-redux-form';
import {Row, Col, Checkbox, ControlLabel} from 'react-bootstrap';
import PageTitle from '../../../../common/page-title';
import RequiredInput from '../../../../common/form/elements/required-input';
import ArrowButton from '../../../../common/button-arrow';
import BackLink from '../../../../common/back-link/index';
import {getPriceIt, getPriceItMeta, createPriceIt, updatePriceIt} from '../../../../../actions/price-it';
import {getProducts} from '../../../../../actions/products';
import { editOverride } from '../../../../../utils/objectivesEditOverride';
import PointsManagementLevel from './points_management_level';
import ImageUpload from '../../../../common/form/elements/image-upload';

import './styles.css';
import RequiredDatePicker from '../../../../common/form/elements/required-datepicker';
import RequiredMultiSelect from '../../../../common/form/elements/required-multi-select';
import EligibilityDropdowns from '../../eligibility-dropdowns';

class AddPriceIts extends Component {
  componentWillMount() {
    this.id = +this.props.match.params.id;
    this.edit = !Number.isNaN(this.id);
    this.props.dispatch(getProducts());
    this.props.dispatch(getPriceItMeta());
    if (this.edit) {
      this.props.dispatch(getPriceIt(this.id));
    } else {
      this.props.dispatch(actions.reset('deep.price_it'));
    }
  }

  componentWillUnmount() {
    this.props.dispatch(actions.reset('deep.price_it'));
  }

  onSubmit = (data) => {
    const {dispatch} = this.props;
    if (this.edit) {
      dispatch(actions.submitFields('deep.price_it', updatePriceIt(this.id, data, dispatch)));
    } else {
      dispatch(actions.submitFields('deep.price_it', createPriceIt(data, dispatch)));
    }
  };

  createProductList = products => products.flatMap(category => (
    category.attributes.products.map(product => ({
      label: `${product.name}`,
      value: product.id
    }))
  ));

  render() {
    const {
      products: productList,
      savedProducts,
      formValid,
      formData
    } = this.props;
    const products = this.createProductList(productList);
    const levelsForm = this.props.meta.levels && this.props.meta.levels.map(level => (
      <PointsManagementLevel
        key={level.id}
        id={level.id}
        name={level.name}
        nextLevel={level.next_level}
        isEdit={editOverride(this)}
      />
    ));
    return (
      <div className='container-fluid price-it-form'>

        <Row>
          <Col md={12}>
            <BackLink href='/admin/objectives/price-it'/>
            <PageTitle>{`${this.edit ? 'EDIT' : 'ADD'} PRICE IT ${(!Number.isNaN(this.id) ? `ID: ${this.id}` : '')}`}</PageTitle>
          </Col>
        </Row>
        <Col md={12}>
          <Row>
            <Form model='deep.price_it' onSubmit={this.onSubmit}>
              <Errors className='errors' model='deep.price_it'/>
              <Row>
                <Col md={12}>
                  <RequiredInput
                    label='Name'
                    tooltip='This name will display to the user in their store performance and points statement pages'
                    model='.name'
                    placeholder='Name'
                    controlId='priceItName'
                  />
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <div className="form-group">
                    <ControlLabel>Description</ControlLabel>
                    <Control.textarea
                      className="form-control"
                      model=".description"
                      rows="5"
                      placeholder="Description"
                    />
                  </div>
                </Col>
              </Row>
              <EligibilityDropdowns
                abm_codes={this.props.abm_codes}
                wse_bands={this.props.wse_bands}
                groups={this.props.groups}
                postcodes={this.props.postcodes}
                sub_zones={this.props.sub_zones}
                zones={this.props.zones}
                model='price_it'
              />
              <Row>
                <Col md={12}>
                  <RequiredDatePicker
                    label="Start Date"
                    controlId="start_date"
                    disabled={editOverride(this)}
                    model="deep.price_it.start_date"
                    value={this.props.startDate}
                  />
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <RequiredDatePicker
                    label="End Date"
                    controlId="end_date"
                    model="deep.price_it.end_date"
                    value={this.props.endDate}
                    required={false}
                  />
                </Col>
              </Row>
              <Row>
                <Col lg={12}>
                  <RequiredMultiSelect
                    model='deep.price_it.product_ids'
                    data={products || []}
                    label="Eligible Products"
                    value={savedProducts}
                    controlId="products"
                    placeholder='Select...'
                  />
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <h4>Price elements to include</h4>
                </Col>
              </Row>
              <Row>
                <Col sm={2}>
                  <Control.checkbox component={Checkbox} model=".price_rrp">
                    price rrp
                  </Control.checkbox>
                </Col>
                <Col sm={2}>
                  <Control.checkbox component={Checkbox} model=".price_list">
                    price list
                  </Control.checkbox>
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <h4>Points management</h4>
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  {levelsForm}
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <RequiredInput
                    label='Maximum points'
                    model='.maximum_points'
                    placeholder='Maximum points'
                    controlId='stockItMaximumPoints'
                  />
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <RequiredDatePicker
                    label="Display From Date"
                    controlId="display_from_date"
                    model="deep.price_it.display_from_date"
                    value={this.props.displayFromDate}
                  />
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <RequiredDatePicker
                    label="Display To Date"
                    controlId="display_to_date"
                    model="deep.price_it.display_to_date"
                    value={this.props.displayToDate}
                    required={false}
                  />
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <ControlLabel>Image*</ControlLabel>
                  <ImageUpload
                    source={(formData.links && formData.links.image) ? formData.links.image : ''}
                    model='deep.price_it.image'
                    sizeLimit={1024 * 1024}
                    type={['image/png', 'image/jpg', 'image/jpeg']}
                    required
                  />
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <ArrowButton className='float-right' color='red' disabled={!formValid}>save</ArrowButton>
                </Col>
              </Row>
            </Form>
          </Row>
        </Col>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  formValid: state.deep.forms.price_it.$form.valid,
  formData: state.deep.price_it,
  startDate: state.deep.price_it.start_date || '',
  endDate: state.deep.price_it.end_date || '',
  displayFromDate: state.deep.price_it.display_from_date || '',
  displayToDate: state.deep.price_it.display_to_date || '',
  currentDateBeforeStartDate: state.deep.price_it.current_date_before_start_date || false,
  groups: state.deep.price_it.groups || [],
  abm_codes: state.deep.price_it.abm_codes || [],
  wse_bands: state.deep.price_it.wse_bands || [],
  postcodes: state.deep.price_it.postcodes || [],
  sub_zones: state.deep.price_it.sub_zones || [],
  zones: state.deep.price_it.zones || [],
  levels: state.deep.price_it.levels || [],
  meta: state.price_its.meta,
  fetching: state.price_its.fetching,
  fetched: state.price_its.fetched,
  savedProducts: state.deep.price_it.product_ids || [],
  products: state.products.products || []
});

export default connect(mapStateToProps)(AddPriceIts);



// WEBPACK FOOTER //
// ./src/components/admin/objectives/price_it/add-price-its/index.jsx